import model from './model';
import { CartButtonController } from './CartButtonController';
import { context } from 'root/context/RootContext';
import { BIReporterService } from 'root/services/biReporterService';
import type { CartButtonNavigationTarget } from 'root/types/cartButton';
import { SPECS } from 'root/appConsts/experiments';

export default model.createController(({ $bindAll, $widget, $w, flowAPI }) => {
  const { bi, environment, controllerConfig, experiments } = flowAPI;
  const { compId } = controllerConfig;
  const { isMobile } = environment;
  context.biReporterService = BIReporterService({
    biLogger: bi,
    environment,
    widgetInstanceId: compId,
  });

  const cartButtonController = new CartButtonController($bindAll, $w, flowAPI);

  const getWidgetPropField = () => {
    const supportCartButtonMobileSettings = experiments.enabled(SPECS.cartButtonMobileSettings);
    return isMobile && supportCartButtonMobileSettings
      ? 'navigationTargetMobile'
      : 'navigationTarget';
  };

  $widget.onPropsChanged(async (prevProps, nextProps) => {
    const prevProp = prevProps[getWidgetPropField()] ?? prevProps.navigationTarget;
    const nextProp = nextProps[getWidgetPropField()] ?? nextProps.navigationTarget;
    if (prevProp !== nextProp) {
      await cartButtonController.init(nextProp as CartButtonNavigationTarget);
    }
  });
  return {
    pageReady: async () => {
      $widget.fireEvent('widgetLoaded', {});
      await cartButtonController.init(
        ($widget.props?.[getWidgetPropField()] ??
          $widget.props.navigationTarget) as CartButtonNavigationTarget
      );
    },
    exports: {},
  };
});
